import { useEffect, useState } from 'react';
import { CnPrint, doLog } from './core';
export { CnPrint, doLog };
export function useCnPrintInstance(props = { isMixPrint: false }) {
    const { isMixPrint } = props;
    const [printInstance, setPrintInstance] = useState(null);
    useEffect(() => {
        if (isMixPrint) {
            setPrintInstance(new CnPrint({
                isNeedWetPrint: true,
                isNeedCloudPrint: true,
                isNeedPddPrint: true,
                isNeedJdPrint: true,
                isNeedBytePrint: true,
                isNeedKuaiShouPrint: true,
                isNeedVipPrint: true, // 是否启用唯品会打印
            }));
        }
        setPrintInstance(new CnPrint());
    }, []);
    return printInstance;
}
window.CnPrint = CnPrint;
window.useCnPrintInstance = useCnPrintInstance;
